import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import assign from 'lodash/assign';
import jsonp from 'jsonp';
import canUseDOM from 'exenv';
import Card from '../card/card';
import Slug from '../slug/slug';

import identityConfig from '../../../config/identity';

import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';

// Documentation: https://trello-attachments.s3.amazonaws.com/580a3710d9cbff5a0b37d59f/5a54ffe84b3d89b9b845315c/c72ec7273cbe62a0de616a408285d781/SmartAdImplementationGuidev2.pdf

export default class Dianomi extends Component {
  constructor(props) {
    super(props);
    this.widgetID = get(identityConfig, 'dianomi.id');
    this.state = {
      dianomiStories: null,
      alreadyCalled: false
    };

    this.transformToMetaData = this.transformToMetaData.bind(this);
  }

  componentDidMount() {
    if (!this.state.dianomiStories && !this.storiesRequested) {
      this.getDianomiData();
      this.storiesRequested = true;
    }
  }

  componentWillReceiveProps(nextProps) {
    const newPostNativeAd = get(nextProps, 'postNativeAd.dianomiTiles.posts');

    if (this.state.alreadyCalled) {
      return;
    }

    if (
      get(newPostNativeAd, 'length') !==
      get(this.props, 'postNativeAd.dianomiTiles.length')
    ) {
      if (!get(this.state, 'dianomiStories')) {
        return;
      }

      const postNativeAdLength = get(newPostNativeAd, 'length', 0);
      let newDianomiStories = this.state.dianomiStories.splice(
        0,
        this.state.dianomiStories.length - postNativeAdLength
      );

      newPostNativeAd.map(data => {
        const modifiedData = data;
        modifiedData.fullyReplaceEyebrow = true;
        modifiedData.customEyebrowText = 'FASTCO.WORKS';
        return data;
      });

      newDianomiStories = [...newPostNativeAd, ...newDianomiStories];

      this.setState({
        dianomiStories: newDianomiStories,
        alreadyCalled: true
      });
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  getDianomiData() {
    if (canUseDOM && !this.state.dianomiStories && !this.storiesRequested) {
      const dianomiAPIEndPoint = `//www.dianomi.com/cgi-bin/smartads.pl?id=${
        this.widgetID
      }&v=2&imgsize=280x157`;

      jsonp(dianomiAPIEndPoint, null, (err, data) => {
        if (get(data, 'campaigns.length')) {
          this.setState({
            dianomiStories: this.transformToMetaData(get(data, 'campaigns', ''))
          });
        }
      });
    }
  }

  transformToMetaData(dianomiStories) {
    const metadata = [];
    dianomiStories.forEach((data, idx) => {
      metadata.push({
        id: `dianomi-${idx}`,
        title: get(data, 'Teaser'),
        link: get(data, 'target_url'),
        featured_image: {
          source: get(data, 'img')
        },
        customEyebrowText: 'Powered by Dianomi',
        targetWindow: 'blank'
      });
    });
    return metadata;
  }

  render() {
    if (!this.state.dianomiStories) {
      return null;
    }
    const { config } = this.props;

    return (
      <section className="more-stories-module post-more-stories">
        <div className="homepage-tag__advertorial-title-container">
          <div>
            <Slug
              slugName="FROM OUR PARTNERS"
              hasSponsoredContentLabel={true}
            />
          </div>
        </div>
        <div className="row row--dianomi">
          {this.state.dianomiStories.map((post, i, arr) => (
            <Card
              key={post.id}
              metadata={assign(post, {
                assetSizes:
                  i === 0
                    ? imageSizesLookup.bigFirstMobile
                    : imageSizesLookup[arr.length]
              })}
              config={config}
              noBottomBorder={true}
              totalCards={arr.length}
            />
          ))}
        </div>
      </section>
    );
  }
}

Dianomi.propTypes = {
  config: PropTypes.shape({}).isRequired
};
